import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "aside-dot absolute w-8 h-8 bg-white flex items-center justify-center rounded-xl" }, [
      _createElementVNode("div", { class: "w-4 h-4 bg-tertiary rounded-xl" })
    ], -1),
    _createElementVNode("div", { class: "aside-line w-1 rounded-md bg-primary h-full" }, null, -1)
  ]))]))
}